const view = /*html*/`

    <!--begin::Container-->
    <div id="kt_content_container" class="container-xxl">        
        <div class="container-fluid">
            <div class="d-md-flex align-items-center justify-content-center text-center">
                <div class="row align-items-center justify-content-center">
                    <div class="col-sm-12 col-md-12 col-lg-12">
                        <div class="d-flex flex-column flex-grow-1 justify-content-center">
                            <h1 class="mb-8">pDxPLAY Desktop Client</h1>
                            <div class="d-flex align-self-center mb-8" style="max-width:90%">
                                <img class="img-fluid" src="assets/media/client/client.png" alt="pDxPLAY"/>
                            </div>
                            <div class="d-flex flex-column align-items-center justify-content-center">
                                <a href="https://pdxplay.net/client/pDxPLAY-Setup.exe" class="btn btn-lg btn-light-primary btn-active-primary btn-active-color-gray-200 external-handler mb-4"><i class="fad fa-cloud-download-alt fs-3 me-1"></i><span data-i18n="example.download">Download</span></a>
                                <p class="text-muted fs-6 fw-bold"><i class="fab fa-windows"></i> Windows 7 · 8 · 8.1 · 10 & 11</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        
    </div>`;           


export default view;